export interface RequestsFilters {}

export enum RequestType {
  WorkerList = 'WorkerList',
  SickLeave = 'SickLeave',
  ExamAnalysis = 'ExamAnalysis',
  NewWorker = 'NewWorker',
  None = 'None'
}

export enum RequestTypeId {
  None = 0,
  WorkerList = 1,
  ManufacturingCharacteristic = 2,
  Telk = 3,
  NewWorker = 4,
  SickLeave = 5,
  ExamAnalysis = 6,
  DeclarationArticle15 = 7,
  Other
}

export enum ServiceTypeId {
  Supplier = 1,
  Consumer = 2,
}
